import axios from 'axios'

export default {
  /**
   *
   * Get user limits data.
   *
   * @param {String} params none, one or multiple query strings without values from: campaigns, creative-studio, content, analytics
   * @returns
   */
  getLimits: () => axios.get(`/api/campaigns/app-limits`),

  getClientLimits: (campaign_id) => axios.get(`/api/campaigns/app-limits/` + campaign_id),
  /**
   *
   * Get user limits data.
   *
   * @param {String} params none, one or multiple query strings without values from: campaigns, creative-studio, content, analytics
   * @returns
   */
  getUsage: (campaign_id) => axios.get(`/api/campaigns/app-usage/${campaign_id ? campaign_id : ''}`),
}
